"use client";

import { c as _c } from "react/compiler-runtime";
import { LeadSourceSelect } from "../lead-source-select";
import { useFormContext } from "react-hook-form";
export default function LeadSourceField(t0) {
  const $ = _c(5);
  const {
    className,
    required: t1
  } = t0;
  const required = t1 === undefined ? false : t1;
  const {
    control,
    formState
  } = useFormContext();
  const t2 = formState.errors.leadSource as any;
  let t3;
  if ($[0] !== className || $[1] !== control || $[2] !== required || $[3] !== t2) {
    t3 = <LeadSourceSelect name="leadSource" control={control} error={t2} required={required} className={className} />;
    $[0] = className;
    $[1] = control;
    $[2] = required;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}